import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { syncApi } from "../lib/api";

const SYNC_REFETCH_DELAY_MS = 5000;

/** Keep との手動同期をトリガーするミューテーションフック */
export const useSyncFromKeep = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const res = await syncApi.keep.$post();
      if (!res.ok) throw new Error("Failed to trigger sync");
    },
    onSuccess: () => {
      toast.success("同期を開始しました");
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["todos"] });
      }, SYNC_REFETCH_DELAY_MS);
    },
    onError: (err) => {
      toast.error("同期の開始に失敗しました");
    },
  });
};
